export default "__VITE_ASSET__ECsI1J$q__"